module.exports = __webpack_public_path__ + "static/media/helicopter_landing_area.59238055.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features/helicopter_landing_area.svg
// module id = 1520
// module chunks = 0